export default defineNuxtRouteMiddleware(async (to, from) => {
  const domain = useRuntimeConfig().public.domain || '';
  if(!to.path.endsWith('/')) return navigateTo({ path: `${ domain }${ to.path }` + '/', query: to.query, hash: to.hash }, { replace: true, redirectCode: 301, external: true })
})